import * as actionTypes from "../constants";

const initialState = {
  // Common states
  loading: false,
  error: null,
  successMessage: null,
  
  // Brands
  brands: [],
  currentBrand: null,
  brandsTotal: 0,
  
  // Sub Brands
  subBrands: [],
  currentSubBrand: null,
  subBrandsTotal: 0,
  subBrandsLoading: false,
  
  // Categories
  categories: [],
  currentCategory: null,
  categoriesTotal: 0,
  categoriesLoading: false,
  
  // Sub-Brand Vendors
  vendors: [],
  currentVendor: null,
  vendorsTotal: 0,
  vendorsLoading: false,

  // Orders
  orders: [],
  currentOrder: null,
  ordersTotal: 0,
  ordersLoading: false,
  ordersMobileNumber: '',
  
  // Transactions
  transactions: [],
  transactionsTotal: 0,
  transactionsLoading: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    // Common actions
    case actionTypes.ADMIN_REQUEST_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case actionTypes.ADMIN_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.successMessage
      };

    case actionTypes.ADMIN_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case actionTypes.ADMIN_CLEAR_ERROR:
      return {
        ...state,
        error: null
      };

    case actionTypes.ADMIN_CLEAR_SUCCESS:
      return {
        ...state,
        successMessage: null
      };

    // Brands actions
    case actionTypes.BRANDS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: action.brands.items || action.brands,
        brandsTotal: action.brands.total || action.brands.length
      };

    case actionTypes.BRAND_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: [action.brand, ...state.brands],
        brandsTotal: state.brandsTotal + 1
      };

    case actionTypes.BRAND_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: state.brands.map(brand =>
          brand.id === action.brand.id ? action.brand : brand
        ),
        currentBrand: action.brand
      };

    case actionTypes.BRAND_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        brands: state.brands.filter(brand => brand.id !== action.brandId),
        brandsTotal: state.brandsTotal - 1,
        currentBrand: state.currentBrand?.id === action.brandId ? null : state.currentBrand
      };

    case actionTypes.BRAND_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentBrand: action.brand,
        brands: state.brands.map(brand =>
          brand.id === action.brand.id ? action.brand : brand
        )
      };

    // Sub Brands actions
    case actionTypes.SUB_BRANDS_LOADING_START:
      return {
        ...state,
        subBrandsLoading: true
      };

    case actionTypes.SUB_BRANDS_FETCH_SUCCESS:
      return {
        ...state,
        subBrandsLoading: false,
        subBrands: action.subBrands.data || action.subBrands,
        subBrandsTotal: action.subBrands.total || action.subBrands.length
      };

    case actionTypes.SUB_BRAND_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        subBrands: [action.subBrand, ...state.subBrands],
        subBrandsTotal: state.subBrandsTotal + 1
      };

    case actionTypes.SUB_BRAND_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        subBrands: state.subBrands.map(subBrand =>
          subBrand.id === action.subBrand.id ? action.subBrand : subBrand
        ),
        currentSubBrand: action.subBrand
      };

    case actionTypes.SUB_BRAND_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        subBrands: state.subBrands.filter(subBrand => subBrand.id !== action.subBrandId),
        subBrandsTotal: state.subBrandsTotal - 1,
        currentSubBrand: state.currentSubBrand?.id === action.subBrandId ? null : state.currentSubBrand
      };

    case actionTypes.SUB_BRAND_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentSubBrand: action.subBrand
      };

    // Vendor actions
    case actionTypes.VENDORS_LOADING_START:
      return {
        ...state,
        vendorsLoading: true,
        error: null
      };

    case actionTypes.VENDORS_FETCH_SUCCESS:
      return {
        ...state,
        vendorsLoading: false,
        vendors: action.vendors.items || action.vendors,
        vendorsTotal: action.vendors.total || (action.vendors.items ? action.vendors.items.length : action.vendors.length)
      };

    case actionTypes.VENDOR_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: [...state.vendors, action.vendor],
        vendorsTotal: state.vendorsTotal + 1
      };

    case actionTypes.VENDOR_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.map(vendor =>
          vendor.id === action.vendor.id ? action.vendor : vendor
        ),
        currentVendor: action.vendor
      };

    case actionTypes.VENDOR_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        vendors: state.vendors.filter(vendor => vendor.id !== action.vendorId),
        vendorsTotal: state.vendorsTotal - 1,
        currentVendor: state.currentVendor?.id === action.vendorId ? null : state.currentVendor
      };

    case actionTypes.VENDOR_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentVendor: action.vendor
      };

    // Categories actions
    case actionTypes.CATEGORIES_LOADING_START:
      return {
        ...state,
        categoriesLoading: true
      };

    case actionTypes.CATEGORIES_FETCH_SUCCESS:
      return {
        ...state,
        categoriesLoading: false,
        categories: action.categories.items || action.categories,
        categoriesTotal: action.categories.total || action.categories.length
      };

    case actionTypes.CATEGORY_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [action.category, ...state.categories],
        categoriesTotal: state.categoriesTotal + 1
      };

    case actionTypes.CATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.map(category =>
          category.id === action.category.id ? action.category : category
        ),
        currentCategory: action.category
      };

    case actionTypes.CATEGORY_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter(category => category.id !== action.categoryId),
        categoriesTotal: state.categoriesTotal - 1,
        currentCategory: state.currentCategory?.id === action.categoryId ? null : state.currentCategory
      };

    case actionTypes.CATEGORY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        currentCategory: action.category
      };

    // Orders actions
    case actionTypes.ORDERS_LOADING_START:
      return {
        ...state,
        ordersLoading: true
      };

    case actionTypes.ORDERS_FETCH_SUCCESS:
      // Handle API response with items field and pagination
      let ordersData = [];
      let totalOrders = 0;
      
      if (action.orders && action.orders.items) {
        // Paginated response with items field (actual API structure)
        ordersData = action.orders.items;
        // Use total from API response for proper pagination
        totalOrders = action.orders.total !== undefined ? action.orders.total : action.orders.items.length;
      } else if (Array.isArray(action.orders)) {
        // Direct array response
        ordersData = action.orders;
        totalOrders = action.orders.length;
      } else if (action.orders && action.orders.data) {
        // Paginated response with data field
        ordersData = action.orders.data;
        totalOrders = action.orders.total !== undefined ? action.orders.total : action.orders.data.length;
      }
      
      return {
        ...state,
        ordersLoading: false,
        orders: ordersData,
        ordersTotal: totalOrders,
        ordersMobileNumber: action.mobileNumber || state.ordersMobileNumber
      };

    case actionTypes.ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        ordersLoading: false,
        currentOrder: action.order
      };

    case actionTypes.ORDERS_CLEAR:
      return {
        ...state,
        orders: [],
        currentOrder: null,
        ordersTotal: 0,
        ordersMobileNumber: ''
      };

    case actionTypes.ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: state.orders.map(order =>
          order.id === action.order.id ? action.order : order
        ),
        currentOrder: state.currentOrder?.id === action.order.id ? action.order : state.currentOrder
      };

    // Transactions actions
    case actionTypes.TRANSACTIONS_LOADING_START:
      return {
        ...state,
        transactionsLoading: true
      };

    case actionTypes.TRANSACTIONS_FETCH_SUCCESS:
      let transactionsData = [];
      let totalTransactions = 0;
      
      if (action.transactions && action.transactions.items) {
        transactionsData = action.transactions.items;
        totalTransactions = action.transactions.total !== undefined ? action.transactions.total : action.transactions.items.length;
      } else if (Array.isArray(action.transactions)) {
        transactionsData = action.transactions;
        totalTransactions = action.transactions.length;
      }
      
      return {
        ...state,
        transactionsLoading: false,
        transactions: transactionsData,
        transactionsTotal: totalTransactions
      };

    case actionTypes.TRANSACTIONS_CLEAR:
      return {
        ...state,
        transactions: [],
        transactionsTotal: 0
      };

    default:
      return state;
  }
};

export default adminReducer;